import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    meta: {
      title: 'Стоматологии',
    },
    path: '/dentals',
    name: 'dentals',
    component: () => import('@/views/DentalsView.vue'),
  },
  {
    meta: {
      title: 'Стоматология',
    },
    path: '/dentals/:id',
    name: 'dental-details',
    component: () => import('@/views/DentalView.vue'),
    props: (route) => {
      const id = Number.parseInt(route.params.id, 10);
      if (Number.isNaN(id)) {
        return { id: 0 };
      }
      return { id };
    },
  },
  {
    meta: {
      title: 'Услуги',
    },
    path: '/services',
    name: 'services',
    component: () => import('@/views/ServicesView.vue'),
  },
  {
    meta: {
      title: 'Поиск стоматологий по услуге из каталога',
    },
    path: '/search/:id',
    name: 'search-by-service',
    component: () => import('@/views/SearchView.vue'),
    props: (route) => {
      const id = Number.parseInt(route.params.id, 10);
      if (Number.isNaN(id)) {
        return { id: 0 };
      }
      return { id };
    },
  },
  {
    meta: {
      title: 'Поиск стоматологий по услуге из каталога в определенном регионе',
    },
    path: '/search/:id/region/:regionId',
    name: 'search-by-service-and-region',
    component: () => import('@/views/SearchView.vue'),
    props: (route) => {
      const id = Number.parseInt(route.params.id, 10);
      if (Number.isNaN(id)) {
        return { id: 0 };
      }
      return { id };
    },
  },
  {
    meta: {
      title: 'Поиск услуги',
    },
    path: '/search',
    name: 'search-service',
    component: () => import('@/views/ServiceSearchView.vue'),
    props: (route) => ({ string: route.query.string }),
  },
  {
    meta: {
      title: 'Контакты',
    },
    path: '/contact',
    name: 'contact',
    component: () => import('@/views/ContactView.vue'),
  },
];

const router = new createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
